import BaseRPCHandler from "./BaseRPCHandler";

export default class WalletWatchAssetHandler extends BaseRPCHandler {
    constructor() {
        super('wallet_watchAsset');
    }
    
    async handle(provider, request) {

    }
}
